import React from 'react';
import { HorizontalScrollView } from '@atlassian/jira-portfolio-3-horizontal-scrolling';
import NowLineComponent from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/timeline/now';
import ReleaseBar from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/timeline/release-bar';
import DefaultTimeUnitsBar from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/timeline/time-units-bar';
import { withSlots, slots } from '@atlassian/jira-portfolio-3-portfolio/src/common/component-slots';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types';

export const Timeline = ({
	width,
	fiscalMonth,
	NowLine = NowLineComponent,
	TimeUnitsBar = DefaultTimeUnitsBar,
}: Props) => (
	<HorizontalScrollView>
		<div
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			className={styles.timeline}
			style={{ width }}
			data-testid="portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.header.axis"
		>
			<TimeUnitsBar fiscalMonth={fiscalMonth} />
			<ReleaseBar width={width} />
			<NowLine topOffset={56} />
		</div>
	</HorizontalScrollView>
);

export default withSlots({ NowLine: slots.NowLine })(Timeline);
